<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" scrollable>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>description</v-icon>
      </v-btn>
    </template>

    <v-card v-if="dialog">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click.native="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('toolbar_title')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click.native="save">{{ $t('save') }}</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 v-if="dialogData">
              <v-text-field
                outline
                color="primary"
                :label="$t('Unternehmen')"
                v-model="company_metadata['Unternehmen']"
              />

              <v-checkbox
                outline
                color="primary"
                :label="$t('Transport')"
                v-model="company_metadata['Transport']"
              />

              <v-checkbox
                outline
                color="primary"
                :label="$t('Spedition')"
                v-model="company_metadata['Spedition']"
              />
              <v-checkbox
                outline
                color="primary"
                :label="$t('Lagerei / Logistik')"
                v-model="company_metadata['Lagerei / Logistik']"
              />

              <v-text-field
                type="number"
                outline
                color="primary"
                :label="$t('Anzahl LKW')"
                v-model="company_metadata['Anzahl LKW']"
              />
              <v-divider />
              <v-text-field
                type="number"
                outline
                color="primary"
                :label="$t('Anzahl Mitarbeiter')"
                readonly
                disabled
                :value="employeeCount"
              />
              <v-flex xs11 offset-xs1>
                <v-text-field
                  type="number"
                  outline
                  color="primary"
                  :label="$t('Büro')"
                  v-model="company_metadata['Anzahl Mitarbeiter']['Büro']"
                />
                <v-text-field
                  type="number"
                  outline
                  color="primary"
                  :label="$t('Gewerblich')"
                  v-model="company_metadata['Anzahl Mitarbeiter']['Gewerblich']"
                />
                <v-text-field
                  type="number"
                  outline
                  color="primary"
                  :label="$t('Fahrer')"
                  v-model="company_metadata['Anzahl Mitarbeiter']['Fahrer']"
                />
              </v-flex>
              <v-divider />
              <v-text-field
                type="number"
                outline
                color="primary"
                :label="$t('Lagerfläche (m²)')"
                v-model="company_metadata['Lagerfläche (m²)']"
              />
              <v-text-field
                type="number"
                outline
                color="primary"
                :label="$t('Anzahl Lagerorte')"
                v-model="company_metadata['Anzahl Lagerorte']"
              />

              <v-select
                :items="typeItems"
                v-model="company_metadata['Art der Prüfung']"
                :label="$t('Art der Prüfung')"
                outline
              ></v-select>
            </v-flex>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="close">{{$t('cancel')}}</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save">{{$t('save')}}</v-btn>
            </v-card-actions>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<i18n>
{
  "de": {
    "toolbar_title": "Unternehmensdaten",
    
    "save": "Speichern",
    "cancel": "Abbrechen"
  },
  "en": {
  }
}
</i18n>

<script>
import _ from "lodash";

import { mapActions } from "vuex";
import { api } from "@/store/modules/audit";

const EmptyMetadata = () => ({
  Unternehmen: "",
  Transport: false,
  Spedition: false,
  "Lagerei / Logistik": false,
  "Anzahl LKW": "",
  "Anzahl Mitarbeiter": {
    Büro: "",
    Gewerblich: "",
    Fahrer: ""
  },

  "Lagerfläche (m²)": "",
  "Anzahl Lagerorte": "",
  "Art der Prüfung": ""
});

export default {
  props: {
    dialogData: {
      type: Object
    }
  },
  components: {},
  data() {
    return {
      dialog: false,
      typeItems: [
        "Erstprüfung",
        "Jährliche QL KG- / Interne Prüfung",
        "Nachprüfung"
      ],
      company_metadata: EmptyMetadata(),
      documentId: null
    };
  },
  computed: {
    employeeCount() {
      return Object.values(this.company_metadata["Anzahl Mitarbeiter"]).reduce(
        (prev, val) => prev + (parseInt(val, 10) || 0),
        0
      );
    }
  },
  watch: {
    dialog(newVal) {
      this.company_metadata = EmptyMetadata();
      this.documentId = null;
      if (newVal && this.dialogData) {
        const data = this.dialogData.companyMetadata || null;
        this.documentId = this.dialogData.id || null;
        if (this.documentId && data) {
          this.company_metadata["Unternehmen"] = data["Unternehmen"];
          this.company_metadata["Transport"] = data["Transport"];
          this.company_metadata["Spedition"] = data["Spedition"];
          this.company_metadata["Lagerei / Logistik"] =
            data["Lagerei / Logistik"];
          this.company_metadata["Anzahl LKW"] = data["Anzahl LKW"];
          this.company_metadata["Anzahl Mitarbeiter"]["Büro"] =
            data["Anzahl Mitarbeiter"]["Büro"];
          this.company_metadata["Anzahl Mitarbeiter"]["Gewerblich"] =
            data["Anzahl Mitarbeiter"]["Gewerblich"];
          this.company_metadata["Anzahl Mitarbeiter"]["Fahrer"] =
            data["Anzahl Mitarbeiter"]["Fahrer"];

          this.company_metadata["Lagerfläche (m²)"] = data["Lagerfläche (m²)"];
          this.company_metadata["Anzahl Lagerorte"] = data["Anzahl Lagerorte"];
          this.company_metadata["Art der Prüfung"] = data["Art der Prüfung"];
        }
      }
    }
  },
  methods: {
    ...mapActions(api.namespace, [api.actions.updateCompanyMetadata]),
    close() {
      this.dialog = false;
    },
    save() {
      console.log(
        "CompanyMetadataDialog",

        this.company_metadata
      );

      this.updateCompanyMetadata({
        AuditId: this.documentId,
        CompanyMetadataUpdateData: _.cloneDeep(this.company_metadata)
      });
      this.close();
    }
  }
};
</script>
